import { defineStore } from 'pinia';

export const useLocalsStore = defineStore('locals', {
  state: () => ({
    data: null,
  }),
});
